import { useMutation } from '@tanstack/react-query';
import config from '@/config';
import api from '@/shared/api';
import HandleHttpError from '@/shared/services/HandleHttpError';
import { useIntl } from 'react-intl';
import ToastrService from '@/shared/services/ToastrService';
import useRemoveDetailRow from './useRemoveDetailRow';
var useBillRegistration = function () {
    var removeDetailRow = useRemoveDetailRow().removeDetailRow;
    var intl = useIntl();
    var mutateAsync = useMutation(function (values) {
        return api.base
            .post("".concat(config.appUrls.api, "/api/IntraCompany/BillRegistration/").concat(values.registrationId))
            .then(function (_a) {
            var data = _a.data;
            return data;
        });
    }, {
        onSuccess: function (invoiceId, x) {
            if (invoiceId) {
                console.log(invoiceId);
                removeDetailRow(x);
                ToastrService.success();
            }
        },
        onError: function (e) {
            HandleHttpError(intl)(e);
        },
    }).mutateAsync;
    return { billRegistration: mutateAsync };
};
export default useBillRegistration;
